import React from "react";
import {Route} from "react-router-dom";
import EditGuaranteeSelection from "../../pages/limitControl/guaranteeSelection/editGuaranteeSelection";
import {EDIT_GUARANTEE_SELECTION_ROUTE} from "../../utils/constants/RoutesConstants";

const GuaranteeSelectionRoutes = () => {
    return (
        <React.Fragment>
            <Route path={EDIT_GUARANTEE_SELECTION_ROUTE} component={EditGuaranteeSelection}/>
        </React.Fragment>
    );
};

export default GuaranteeSelectionRoutes;